"use client";

import { useDispatch } from "react-redux";
import { closeModal } from "@/src/store/slices/allModalSlice";
import { useDeleteUserAccountMutation } from "@/src/store/rtkQueries/userPostAPI";
import { clearAllCookiesAndReload } from "@/src/utils/authCookies";
import { Button } from "@heroui/react";
import Loader from "@/src/ui/Loader";
import { TrashIconSVG } from "@/src/ui/AllSVG";
import { toast } from "@/src/lib/toast";
import { getHomePath } from "@/src/routes/routes";

export default function DeleteAccountModal() {
    const dispatch = useDispatch();
    const [deleteUserAccount, { isLoading }] = useDeleteUserAccountMutation();

    const handleDelete = async () => {
        try {
            const response = await deleteUserAccount(undefined).unwrap();
            if (response.http_status_code === 200 || response.http_status_code === 201) {
                toast.success(response.message || "Account deleted successfully");
                dispatch(closeModal());
                clearAllCookiesAndReload(getHomePath());
            }
        } catch (error) {
            console.error("Error deleting account", error);
        }
    };

    return (
        <div className="flex flex-col items-center gap-6 py-2 text-center">
            {isLoading && <Loader />}

            <div className="flex items-center justify-center w-14 h-14 rounded-full bg-red-50">
                <TrashIconSVG />
            </div>

            <div className="space-y-1.5">
                <h3 className="text-base font-semibold">Delete Account</h3>
                <p className="text-sm text-body-color/60 max-w-xs">
                    Are you sure you want to permanently delete your account and all associated data? This action{" "}
                    <span className="font-medium text-red-500">cannot be undone</span>.
                </p>
            </div>

            <div className="flex gap-3 w-full">
                <Button
                    onPress={() => dispatch(closeModal())}
                    isDisabled={isLoading}
                    className="flex-1 border border-muted-color bg-transparent text-body-color text-sm font-medium rounded-full py-2.5"
                >
                    Cancel
                </Button>
                <Button
                    onPress={handleDelete}
                    isDisabled={isLoading}
                    className="flex-1 bg-red-500 text-white text-sm font-medium rounded-full py-2.5"
                >
                    Delete Account
                </Button>
            </div>
        </div>
    );
}
